import { PASSWORD_MIN_LENGTH } from '@fluxus/shared';
import { Check, X } from 'lucide-react';
import { cn } from '@/lib/cn';

/** Regras da senha (as mesmas do passwordSchema), mostradas enquanto a pessoa digita. */
const RULES = [
  {
    label: `Pelo menos ${PASSWORD_MIN_LENGTH} caracteres`,
    test: (v: string) => v.length >= PASSWORD_MIN_LENGTH,
  },
  { label: 'Pelo menos uma letra', test: (v: string) => /[A-Za-zÀ-ÿ]/.test(v) },
  { label: 'Pelo menos um número', test: (v: string) => /\d/.test(v) },
];

export function PasswordRules({ password }: { password: string }) {
  return (
    <ul aria-label="Regras da senha" className="mt-1 flex flex-col gap-1 text-sm">
      {RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.label}
            className={cn('flex items-center gap-2', ok ? 'text-status-green-fg' : 'text-muted-foreground')}
          >
            {ok ? <Check className="size-4" aria-hidden /> : <X className="size-4" aria-hidden />}
            {rule.label}
            <span className="sr-only">{ok ? '(atendida)' : '(pendente)'}</span>
          </li>
        );
      })}
    </ul>
  );
}

/** Token de um link de e-mail (fragmento #token=...): o fragmento não vai para servidores nem no Referer. */
export function tokenFromHash(): string {
  return new URLSearchParams(window.location.hash.slice(1)).get('token') ?? '';
}

/** Tira o token do endereço (histórico, capturas de tela) depois de guardado no estado. */
export function clearHash(): void {
  if (window.location.hash) {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  }
}
